<template>
  <div>
    <div class="reminder-info">
      <slot />
      <div class="reminder-btn" @click="back">
        返回
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppErrReminder',
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'job' })
      }
    },
  },
};
</script>

<style lang="less" scoped>
.reminder-info {
  padding-top: 300px;
  text-align: center;
  color: #333;
  font-size: 30px;
  .reminder-btn {
    width: 590px;
    height: 90px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(76, 180, 255, 1);
    color: #4a88f7;
    border-radius: 8px;
    line-height: 90px;
    font-size: 32px;
    font-weight: 500;
    margin: 100px auto 0;
  }
}
</style>
